import React, { useState } from 'react';
import { useAuthStore } from '../stores/useAuthStore';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, Loader2 } from 'lucide-react';
import { DS } from '../theme/DesignSystem';
import { clsx } from 'clsx';

export const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { signIn, loading, error } = useAuthStore();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await signIn(email, password);
      navigate('/');
    } catch (err) {
      // Error handled in store
    }
  };

  return (
    <div className="min-h-screen bg-stone-50 flex flex-col p-8 justify-center animate-page">
      <div className="w-full max-w-sm mx-auto space-y-10">
        {/* Branding */}
        <div className="space-y-3">
          <div className="w-11 h-11 bg-blue-600 rounded-2xl mb-5 shadow-lg shadow-blue-600/20 flex items-center justify-center">
            <span className="text-white font-bold text-base">S</span>
          </div>
          <h1 className="text-3xl font-bold tracking-tighter text-slate-900">SampleIntel.</h1>
          <p className="text-slate-400 font-medium text-sm">Sign in to continue</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-5">
          {error && (
            <div className="p-3.5 bg-red-50 text-red-600 text-xs font-bold border border-red-100 rounded-xl animate-slide-down">
              {error}
            </div>
          )}

          <div className="space-y-3.5">
            <div>
              <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-1.5 ml-1">Email</label>
              <input
                type="email" required
                className="w-full bg-white border border-slate-200 rounded-xl px-4 py-3.5 text-sm text-slate-800 placeholder:text-slate-300 focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-400 transition-all font-medium"
                placeholder="user@factory.com"
                value={email} onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div>
              <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-1.5 ml-1">Password</label>
              <input
                type="password" required
                className="w-full bg-white border border-slate-200 rounded-xl px-4 py-3.5 text-sm text-slate-800 placeholder:text-slate-300 focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-400 transition-all font-medium"
                placeholder="••••••••"
                value={password} onChange={(e) => setPassword(e.target.value)}
              />
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-blue-600 text-white rounded-2xl py-3.5 font-bold text-sm flex justify-between items-center px-6 shadow-md shadow-blue-600/20 active:scale-[0.98] transition-all disabled:opacity-60 group"
          >
            {loading ? (
              <Loader2 size={18} className="animate-spin mx-auto" />
            ) : (
              <>
                <span>Sign In</span>
                <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
              </>
            )}
          </button>
        </form>

        <p className="text-center text-[10px] text-slate-300 font-medium">Factory OS v2.0</p>
      </div>
    </div>
  );
};